import { useCometState } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
import { domainFromURL } from '#pplx/frontend/common/files/urls.js';
import { useCallback, useMemo, useRef } from 'react';
const STORAGE_KEY = 'pplx.promo_suggestion_shimmer';
const MAX_SEEN_DOMAINS = 3;
function readSeenDomains() {
    try {
        const raw = SafeLocalStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    }
    catch {
        return [];
    }
}
function persistDomain(domain) {
    const seen = readSeenDomains();
    if (seen.includes(domain))
        return;
    SafeLocalStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, domain]));
}
export function usePromoShimmerEligibility() {
    const { sidecarSourceTab: { url: sidecarUrl }, } = useCometState();
    const currentDomain = useMemo(() => {
        if (!sidecarUrl)
            return null;
        const domain = domainFromURL(sidecarUrl);
        return domain === 'unknown' ? null : domain;
    }, [sidecarUrl]);
    const eligibilityRef = useRef({
        domain: null,
        eligible: false,
    });
    const markedRef = useRef(false);
    if (currentDomain !== eligibilityRef.current.domain) {
        const seen = readSeenDomains();
        eligibilityRef.current = {
            domain: currentDomain,
            eligible: currentDomain !== null && seen.length < MAX_SEEN_DOMAINS && !seen.includes(currentDomain),
        };
        markedRef.current = false;
    }
    const markSeen = useCallback(() => {
        if (markedRef.current || !currentDomain)
            return;
        markedRef.current = true;
        persistDomain(currentDomain);
    }, [currentDomain]);
    return { eligible: eligibilityRef.current.eligible, domain: currentDomain, markSeen };
}
//# sourceMappingURL=usePromoSuggestionShimmer.js.map